import { Box, BoxProps, Loader, Text, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'

interface ButtonProps {
  type?: keyof typeof buttonTypes | Array<keyof typeof buttonTypes>
  onPress: () => void | Promise<any> | Array<() => void | Promise<any>>
  isLoading?: boolean | Array<boolean>
  disabled?: boolean | Array<boolean>
  title?: string | Array<string>
  isRound?: boolean | Array<boolean>
  isFull?: boolean | Array<boolean>
  testID?: string
  bgColor: string
  textColor: string
}

const defaultStyles = {
  text: (textColor: string) =>
    ({
      color: textColor,
      fontFamily: 'jioType-medium',
    } as TextProps),
  container: (isRound: boolean, isFull: boolean, bgColor: string) =>
    ({
      height: 'MEDIUM_2',
      width: isFull ? undefined : 177,
      justifyContent: 'center',
      alignSelf: isFull ? 'stretch' : undefined,
      alignItems: 'center',
      backgroundColor: bgColor,
      borderRadius: isRound ? 24 : 'MEDIUM',
      underlayColor: bgColor,
    } as BoxProps),
  disabledOpacity: 0.5,
}

const buttonTypes = {
  primary: {
    ...defaultStyles,
  },
  secondary: {
    ...defaultStyles,
    container: (isRound: boolean, isFull: boolean, bgColor: string) =>
      ({
        height: 'MEDIUM_2',
        width: isFull ? undefined : 'HUGE',
        justifyContent: 'center',
        alignSelf: isFull ? 'stretch' : undefined,
        alignItems: 'center',
        borderRadius: isRound ? 24 : 'MEDIUM',
        underlayColor: bgColor,
        borderColor: bgColor,
        borderWidth: 1,
        backgroundColor: 'WHITE',
      } as BoxProps),
    text: (texColor: string, isPressed: boolean) =>
      ({
        color: isPressed ? 'WHITE' : texColor,
      } as TextProps),
  },
}

export const ButtonComp: FC<ButtonProps> = (props) => {
  const { children, testID, bgColor, textColor } = props
  const {
    type = 'primary',
    isLoading: propsLoading,
    onPress,
    title,
    isRound = false,
    isFull = false,
    disabled = false,
  } = props
  const [pressState, setPressState] = useState(false)
  const [isLoading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(!!propsLoading as boolean)
  }, [propsLoading])
  const onPressInternal = async () => {
    if (isLoading || disabled) {
      return
    }
    try {
      if (propsLoading === undefined) {
        setLoading(true)
      }
      if (onPress) {
        await onPress()
      }
      if (propsLoading === undefined) {
        setLoading(false)
      }
    } catch (ex) {
      if (propsLoading === undefined) {
        setLoading(false)
      }
      throw ex
    }
  }
  const contents = children ? (
    children
  ) : (
    <>
      <Text {...buttonTypes[type as keyof typeof buttonTypes].text(textColor, pressState)}>{title}</Text>
    </>
  )
  return (
    <Box
      height="48"
      justifyContent="center"
      alignItems="center"
      testID={testID}
      disabled={disabled}
      onPress={onPressInternal}
      onPressIn={() => setPressState(true)}
      onPressOut={() => setPressState(false)}
      opacity={disabled ? buttonTypes[type as keyof typeof buttonTypes].disabledOpacity : 1}
      {...buttonTypes[type as keyof typeof buttonTypes].container(isRound as boolean, isFull as boolean, bgColor)}>
      {isLoading ? <Loader testID="buttonLoader" color="WHITE" /> : contents}
    </Box>
  )
}
